import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "作業計画及び日報", -1)
const _hoisted_2 = {
  key: 0,
  style: {"color":"blue"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 0,
  style: {"background-color":"lightgray","position":"absolute","top":"0%","left":"0%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  style: {"position":"absolute","top":"1%","right":"1%","color":"lightgray"}
}
const _hoisted_7 = { style: {"position":"absolute","top":"1%","right":"1%"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { style: {"position":"absolute","top":"20px","right":"1%"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  style: {"position":"fixed","top":"0","left":"0","width":"100%","height":"100%","background-color":"white"}
}
const _hoisted_15 = { style: {"float":"left"} }
const _hoisted_16 = { style: {"float":"right"} }
const _hoisted_17 = { style: {"overflow":"auto","height":"85vh","margin-top":"30px"} }
const _hoisted_18 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { style: {"width":"100%","margin-top":"25px","border-radius":"10px"} }
const _hoisted_30 = { style: {"width":"100%","margin":"5px","padding-top":"15px"} }
const _hoisted_31 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_32 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_33 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = {
  key: 2,
  style: {"width":"100%","margin":"5px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { style: {"width":"100%","margin-top":"25px","border-radius":"10px"} }
const _hoisted_42 = { style: {"width":"100%","margin":"5px","padding-top":"15px"} }
const _hoisted_43 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_44 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_45 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_46 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = {
  key: 1,
  style: {"width":"100%","margin":"5px"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { style: {"width":"100%","margin":"5px"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_float_button = _resolveComponent("a-float-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_caret_left_outlined = _resolveComponent("caret-left-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_caret_right_outlined = _resolveComponent("caret-right-outlined")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_a_float_button, { key: 0 }, {
          icon: _withCtx(() => [
            _createVNode(_component_a_spin, { style: {"margin-top":"5px"} })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createVNode(_component_a_switch, {
      checked: _ctx.staffViewMode,
      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.staffViewMode) = $event)),
      loading: _ctx.loading,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModeChange()))
    }, {
      checkedChildren: _withCtx(() => [
        _createTextVNode("全体を表示中")
      ]),
      unCheckedChildren: _withCtx(() => [
        _createTextVNode("自分だけを表示中")
      ]),
      _: 1
    }, 8, ["checked", "loading"]),
    _createVNode(_component_a_select, {
      options: _ctx.bushoSource,
      mode: "tags",
      placeholder: "部署選択",
      value: _ctx.bushofilter,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bushofilter) = $event)),
      style: {"width":"100%","margin-top":"5px"},
      onChange: _ctx.bushofilterChanged,
      disabled: !_ctx.staffViewMode
    }, null, 8, ["options", "value", "onChange", "disabled"]),
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeKey) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "個人スケジューラー"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_caret_left_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.beforeMonth
            }, null, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              onClick: _ctx.thisMonth,
              style: {"margin-bottom":"5px","position":"relative","bottom":"7px"},
              disabled: _ctx.isThisMonth
            }, {
              default: _withCtx(() => [
                _createTextVNode("今月")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_caret_right_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.afterMonth
            }, null, 8, ["onClick"]),
            _createVNode(_component_datepicker, {
              "onUpdate:modelValue": [
                _ctx.monthUpdate,
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectMonthValue) = $event))
              ],
              locale: "jp",
              format: "yyyy年M月",
              "month-picker": "",
              clearable: false,
              "auto-apply": true,
              "enable-time-picker": false,
              modelValue: _ctx.selectMonthValue,
              style: {"width":"200px","display":"inline-block","bottom":"7px"}
            }, null, 8, ["onUpdate:modelValue", "modelValue"]),
            _createVNode(_component_a_table, {
              bordered: "",
              columns: _ctx.monthlyColumns,
              dataSource: _ctx.monthlyDataSource,
              pagination: false,
              scroll: { y: '60vh' }
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.dataIndex === 'sat')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(column.title), 1))
                  : (column.dataIndex === 'sun')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(column.title), 1))
                    : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({column,record,text,}) => [
                (column.dataIndex === 'mon')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createTextVNode(_toDisplayString(_ctx.selectMonth.month() + 1) + "月 ", 1),
                      _hoisted_5,
                      _createTextVNode(" 第 " + _toDisplayString(record.week + 1) + " 週 ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectMonth.month() !== text.getMonth())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(text.getMonth() + 1) + " / " + _toDisplayString(text.getDate()), 1))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      style: _normalizeStyle(_ctx.fontWeight(text))
                    }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(text.getDate()), 1)
                    ], 4)),
                _hoisted_8,
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.fontWeight(text))
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getHolyDayDetail(text)), 1)
                ], 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.schedules, (schedule) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: schedule }, [
                    (schedule.date === text.toLocaleDateString('ja-JP'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (schedule.staff === _ctx.loginUserID)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (schedule.project === 0)
                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 0,
                                      color: "red",
                                      onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                    }, {
                                      default: _withCtx(() => [
                                        (schedule.achieve)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" 半休(" + _toDisplayString(schedule.achieve) + "H) ", 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode("休み")
                                            ], 64))
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (schedule.achieve || schedule.overtime)
                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 1,
                                        color: "blue",
                                        onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.viweScheduleCode(schedule)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 2,
                                        onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.viweScheduleCode(schedule)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["columns", "dataSource"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "作業者スケジューラー"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_caret_left_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.beforeWeek
            }, null, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              onClick: _ctx.thisWeek,
              style: {"margin-bottom":"5px","position":"relative","bottom":"7px"},
              disabled: _ctx.isThisWeek
            }, {
              default: _withCtx(() => [
                _createTextVNode("今週")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_caret_right_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.afterWeek
            }, null, 8, ["onClick"]),
            _createVNode(_component_datepicker, {
              "onUpdate:modelValue": [
                _ctx.weekUpdate,
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectWeekList) = $event))
              ],
              locale: "jp",
              format: _ctx.weekFormat,
              weekPicker: "",
              clearable: false,
              "auto-apply": true,
              "enable-time-picker": false,
              modelValue: _ctx.selectWeekList,
              style: {"width":"200px","display":"inline-block","bottom":"7px"}
            }, null, 8, ["onUpdate:modelValue", "format", "modelValue"]),
            _createVNode(_component_a_table, {
              bordered: "",
              columns: _ctx.staffColumnsBushoFilter,
              "data-source": _ctx.staffDataSource,
              pagination: false,
              scroll: { x: (_ctx.staffColumnsBushoFilter.length * 200) }
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.dataIndex==='staff')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(column.title) + " ", 1),
                      (_ctx.getOverTime(column.code))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_10,
                            _createVNode(_component_a_tag, { color: "red" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getOverTime(column.code)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({ column ,record ,}) => [
                (column.dataIndex==='date')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle(_ctx.fontWeight(record.date))
                    }, [
                      _createTextVNode(_toDisplayString(record.date.getDate()) + "日(" + _toDisplayString(record.day) + ") ", 1),
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.getHolyDayDetail(record.date)), 1)
                    ], 4))
                  : _createCommentVNode("", true),
                (column.dataIndex==='staff')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(record.schedules, (schedule) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: schedule }, [
                        (column.code===schedule.staff)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (schedule.date === record.date.toLocaleDateString('ja-JP'))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (schedule.project === 0)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "red",
                                          onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                        }, {
                                          default: _withCtx(() => [
                                            (schedule.achieve)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" 半休(" + _toDisplayString(schedule.achieve) + "H) ", 1)
                                                ], 64))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode("休み")
                                                ], 64))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (schedule.achieve || schedule.overtime)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "blue",
                                            onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "scroll"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "3",
          tab: "週スケジューラー"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_caret_left_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.beforeWeek
            }, null, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              onClick: _ctx.thisWeek,
              style: {"margin-bottom":"5px","position":"relative","bottom":"7px"},
              disabled: _ctx.isThisWeek
            }, {
              default: _withCtx(() => [
                _createTextVNode("今週")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_caret_right_outlined, {
              style: { fontSize: '32px' },
              onClick: _ctx.afterWeek
            }, null, 8, ["onClick"]),
            _createVNode(_component_datepicker, {
              "onUpdate:modelValue": [
                _ctx.weekUpdate,
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectWeekList) = $event))
              ],
              locale: "jp",
              format: _ctx.weekFormat,
              weekPicker: "",
              clearable: false,
              "auto-apply": true,
              "enable-time-picker": false,
              modelValue: _ctx.selectWeekList,
              style: {"width":"200px","display":"inline-block","bottom":"7px"}
            }, null, 8, ["onUpdate:modelValue", "format", "modelValue"]),
            _createVNode(_component_a_table, {
              bordered: "",
              columns: _ctx.weeklyColumns,
              "data-source": _ctx.weeklyDataSourceBushoFilter,
              pagination: false,
              scroll: { y: '60vh' }
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.date)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: _normalizeStyle(_ctx.fontWeight(column.date))
                    }, [
                      _createTextVNode(_toDisplayString(column.title) + " ", 1),
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.getHolyDayDetail(column.date)), 1)
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({column,record,}) => [
                (column.dataIndex==='staff')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(record.staff.title) + " ", 1),
                      (_ctx.getOverTime(record.staff.code))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_13,
                            _createVNode(_component_a_tag, { color: "red" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getOverTime(record.staff.code)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (column.dataIndex==='schedules')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(record.schedules, (schedule) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: schedule }, [
                          (record.staff.code === schedule.staff)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (schedule.date === column.date.toLocaleDateString('ja-JP'))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (schedule.project === 0)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "red",
                                            onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                          }, {
                                            default: _withCtx(() => [
                                              (schedule.achieve)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(" 半休(" + _toDisplayString(schedule.achieve) + "H) ", 1)
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode("休み")
                                                  ], 64))
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (schedule.achieve || schedule.overtime)
                                          ? (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 1,
                                              color: "blue",
                                              onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 2,
                                              onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createElementVNode("div", null, [
      (_ctx.fullVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_a_page_header, {
              style: {"border":"1px solid rgb(235, 237, 240)"},
              title: _ctx.modalTitle,
              onBack: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setFullVisivle(false)))
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_button, {
                  key: "2",
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ()=>{_ctx.registAchieve.action = null; _ctx.registAchieve.achieve = null; _ctx.restmode=null; _ctx.holidayVisible=true;}),
                  style: {"background-color":"red"},
                  disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("休")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_a_button, {
                  key: "1",
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputScheduleVisible(null))),
                  disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("+")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_a_layout, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, { style: {"background-color":"white"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        style: {"display":"flex","justify-content":"center","align-items":"center"},
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.beforeDay && _ctx.beforeDay(...args)))
                      }, [
                        _createVNode(_component_caret_left_outlined, { style: { fontSize: '32px',verticalAlign:'middle' } }),
                        _createTextVNode(" 前日 ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        style: {"display":"flex","justify-content":"center","align-items":"center"},
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.afterDay && _ctx.afterDay(...args)))
                      }, [
                        _createTextVNode(" 翌日 "),
                        _createVNode(_component_caret_right_outlined, { style: { fontSize: '32px',verticalAlign:'middle' } })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, [
                        _createTextVNode("合計実績："),
                        _createElementVNode("b", null, _toDisplayString(_ctx.getSumAchieve()), 1),
                        _createTextVNode("Ｈ "),
                        (_ctx.getSumOvertime())
                          ? (_openBlock(), _createElementBlock("text", _hoisted_18, [
                              _hoisted_19,
                              _createTextVNode("合計残業："),
                              _createElementVNode("b", null, _toDisplayString(_ctx.getSumOvertime()), 1),
                              _createTextVNode("Ｈ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalAchieves, (schedule) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: schedule }, [
                          (schedule.project == 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_a_tag, {
                                  color: "red",
                                  style: {"width":"90%","margin-top":"10px","text-align":"center"},
                                  onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                }, {
                                  default: _withCtx(() => [
                                    (schedule.achieve)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" 半休(" + _toDisplayString(schedule.achieve) + "H) ", 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("休み")
                                        ], 64)),
                                    (schedule.action)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _hoisted_20,
                                          _createTextVNode(" " + _toDisplayString(schedule.action), 1)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (schedule.addChange)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _hoisted_21,
                                          _createTextVNode(" " + _toDisplayString(schedule.addChange), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _hoisted_22
                              ], 64))
                            : (schedule.achieve || schedule.overtime)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_a_tag, {
                                    color: "blue",
                                    style: {"width":"90%","margin-top":"10px","text-align":"center"},
                                    onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)) + " ", 1),
                                      (schedule.action)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_23,
                                            _createTextVNode(" " + _toDisplayString(schedule.action), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (schedule.addChange)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_24,
                                            _createTextVNode(" " + _toDisplayString(schedule.addChange), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _hoisted_25
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createVNode(_component_a_tag, {
                                    style: {"width":"90%","margin-top":"10px","text-align":"center"},
                                    onClick: ($event: any) => (_ctx.inputScheduleVisible(schedule))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.viweSchedule(schedule)) + " ", 1),
                                      (schedule.action)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_26,
                                            _createTextVNode(" " + _toDisplayString(schedule.action), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (schedule.addChange)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_27,
                                            _createTextVNode(" " + _toDisplayString(schedule.addChange), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _hoisted_28
                                ], 64))
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.isPC)
                  ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                      key: 0,
                      width: "480",
                      style: {"background-color":"white","margin":"30px","border-color":"black","padding":"20px","text-align":"left"}
                    }, {
                      default: _withCtx(() => [
                        (_ctx.registAchieve.project!=0)
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 0,
                              options: _ctx.projects,
                              "show-search": "",
                              placeholder: "工事選択",
                              value: _ctx.registAchieve.project,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registAchieve.project) = $event)),
                              "filter-option": _ctx.filterOption,
                              style: {"width":"100%"},
                              disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                            }, null, 8, ["options", "value", "filter-option", "disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.registAchieve.project!=0)
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 1,
                              options: _ctx.workCodes,
                              "show-search": "",
                              placeholder: "行程番号",
                              value: _ctx.registAchieve.code,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.registAchieve.code) = $event)),
                              "filter-option": _ctx.filterOption,
                              style: {"width":"100%","margin-top":"5px"},
                              disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                            }, null, 8, ["options", "value", "filter-option", "disabled"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_29, [
                          (_ctx.registAchieve.project!=0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createTextVNode(" 計画 "),
                                  _createVNode(_component_a_input_number, {
                                    placeholder: "計画",
                                    "addon-after": "H",
                                    value: _ctx.registAchieve.plan,
                                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registAchieve.plan) = $event)),
                                    min: 0,
                                    style: {"float":"right","margin-right":"15px"},
                                    inputmode: "decimal",
                                    disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                                  }, null, 8, ["value", "disabled"])
                                ]),
                                _createVNode(_component_a_divider, {
                                  style: {"border-color":"#dee0e0"},
                                  dashed: ""
                                }),
                                _createElementVNode("div", _hoisted_31, [
                                  _createTextVNode(" 実績(現在の合計:" + _toDisplayString(_ctx.getSumAchieve()) + "H) ", 1),
                                  _createVNode(_component_a_input_number, {
                                    placeholder: "実績",
                                    "addon-after": "H",
                                    value: _ctx.registAchieve.achieve,
                                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.registAchieve.achieve) = $event)),
                                    min: 0,
                                    style: {"float":"right","margin-right":"15px"},
                                    inputmode: "decimal",
                                    disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                                  }, null, 8, ["value", "disabled"])
                                ]),
                                _createVNode(_component_a_divider, {
                                  style: {"border-color":"#dee0e0"},
                                  dashed: ""
                                }),
                                _createElementVNode("div", _hoisted_32, [
                                  _createTextVNode(" 本数 "),
                                  _createVNode(_component_a_input_number, {
                                    placeholder: "本数",
                                    "addon-after": "本",
                                    value: _ctx.registAchieve.number,
                                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.registAchieve.number) = $event)),
                                    min: 0,
                                    style: {"float":"right","margin-right":"15px"},
                                    inputmode: "decimal",
                                    disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                                  }, null, 8, ["value", "disabled"])
                                ]),
                                _createVNode(_component_a_divider, {
                                  style: {"border-color":"#dee0e0"},
                                  dashed: ""
                                }),
                                (_ctx.getEditType(_ctx.registAchieve.staff) == 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createTextVNode(" 残業(現在の合計:" + _toDisplayString(_ctx.getSumOvertime()) + "H) ", 1),
                                        _createVNode(_component_a_input_number, {
                                          placeholder: "残業",
                                          "addon-after": "H",
                                          value: _ctx.registAchieve.overtime,
                                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.registAchieve.overtime) = $event)),
                                          min: 0,
                                          style: {"float":"right","margin-right":"15px"},
                                          inputmode: "decimal",
                                          disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                                        }, null, 8, ["value", "disabled"])
                                      ]),
                                      _createVNode(_component_a_divider, {
                                        style: {"border-color":"#dee0e0"},
                                        dashed: ""
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.getEditType(_ctx.registAchieve.staff) != 0 && _ctx.registAchieve.project==0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_a_radio_group, {
                                  value: _ctx.restmode,
                                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.restmode) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, { value: "full" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("全休")
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_34,
                                    _createVNode(_component_a_radio, { value: "part" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("半休")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createTextVNode(" 休んだ時間 "),
                                  _createVNode(_component_a_input_number, {
                                    placeholder: "休んだ時間",
                                    "addon-after": "H",
                                    value: _ctx.registAchieve.achieve,
                                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.registAchieve.achieve) = $event)),
                                    min: 0,
                                    style: {"float":"right","margin-right":"15px"},
                                    inputmode: "decimal",
                                    disabled: _ctx.restmode!='part'
                                  }, null, 8, ["value", "disabled"])
                                ]),
                                _hoisted_36
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _createTextVNode(" 補足"),
                            _hoisted_38,
                            _createVNode(_component_a_input, {
                              placeholder: "補足",
                              value: _ctx.registAchieve.action,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.registAchieve.action) = $event)),
                              style: {"margin-right":"35px","margin-bottom":"20px"},
                              disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                            }, null, 8, ["value", "disabled"])
                          ]),
                          (_ctx.registAchieve.project!=0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createTextVNode(" 追加変更"),
                                _hoisted_40,
                                _createVNode(_component_a_textarea, {
                                  placeholder: "追加変更",
                                  value: _ctx.registAchieve.addChange,
                                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.registAchieve.addChange) = $event)),
                                  style: {"margin-right":"35px","margin-bottom":"20px"},
                                  disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                                }, null, 8, ["value", "disabled"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_button, {
                          style: {"float":"left"},
                          type: "primary",
                          danger: "",
                          disabled: _ctx.registAchieve.id==0|| _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority,
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteAchieve(_ctx.registAchieve)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("削除")
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_a_button, {
                          style: {"float":"right"},
                          type: "primary",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editSave())),
                          disabled: _ctx.isAchieveRegist() || _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("保存")
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_a_button, {
                          style: {"float":"right","margin-right":"5px"},
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.inputScheduleVisible(null))),
                          disabled: _ctx.registAchieve.id==0
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新規登録")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        open: _ctx.modalVisible,
        "onUpdate:open": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modalVisible) = $event)),
        title: _ctx.modalTitle,
        onOk: _ctx.handleOk,
        width: _ctx.isPC ? '480px':'100%'
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            style: {"float":"left"},
            type: "primary",
            danger: "",
            disabled: _ctx.registAchieve.id==0|| _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority,
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.deleteAchieve(_ctx.registAchieve)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("削除")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.modalVisible=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("キャンセル")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.editSave())),
            disabled: _ctx.isAchieveRegist() || _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          (_ctx.registAchieve.project!=0)
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 0,
                options: _ctx.projects,
                "show-search": "",
                placeholder: "工事選択",
                value: _ctx.registAchieve.project,
                "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.registAchieve.project) = $event)),
                "filter-option": _ctx.filterOption,
                style: {"width":"100%"},
                disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
              }, null, 8, ["options", "value", "filter-option", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.registAchieve.project!=0)
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                options: _ctx.workCodes,
                "show-search": "",
                placeholder: "行程番号",
                value: _ctx.registAchieve.code,
                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.registAchieve.code) = $event)),
                "filter-option": _ctx.filterOption,
                style: {"width":"100%","margin-top":"5px"},
                disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
              }, null, 8, ["options", "value", "filter-option", "disabled"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            (_ctx.registAchieve.project!=0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createTextVNode(" 計画 "),
                    _createVNode(_component_a_input_number, {
                      placeholder: "計画",
                      "addon-after": "H",
                      value: _ctx.registAchieve.plan,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.registAchieve.plan) = $event)),
                      min: 0,
                      style: {"float":"right","margin-right":"15px"},
                      inputmode: "decimal",
                      disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _createVNode(_component_a_divider, {
                    style: {"border-color":"#dee0e0"},
                    dashed: ""
                  }),
                  _createElementVNode("div", _hoisted_43, [
                    _createTextVNode(" 実績(現在の合計:" + _toDisplayString(_ctx.getSumAchieve()) + "H) ", 1),
                    _createVNode(_component_a_input_number, {
                      placeholder: "実績",
                      "addon-after": "H",
                      value: _ctx.registAchieve.achieve,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.registAchieve.achieve) = $event)),
                      min: 0,
                      style: {"float":"right","margin-right":"15px"},
                      inputmode: "decimal",
                      disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _createVNode(_component_a_divider, {
                    style: {"border-color":"#dee0e0"},
                    dashed: ""
                  }),
                  _createElementVNode("div", _hoisted_44, [
                    _createTextVNode(" 本数 "),
                    _createVNode(_component_a_input_number, {
                      placeholder: "本数",
                      "addon-after": "本",
                      value: _ctx.registAchieve.number,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.registAchieve.number) = $event)),
                      min: 0,
                      style: {"float":"right","margin-right":"15px"},
                      inputmode: "decimal",
                      disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _createVNode(_component_a_divider, {
                    style: {"border-color":"#dee0e0"},
                    dashed: ""
                  }),
                  (_ctx.getEditType(_ctx.registAchieve.staff) == 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createTextVNode(" 残業(現在の合計:" + _toDisplayString(_ctx.getSumOvertime()) + "H) ", 1),
                          _createVNode(_component_a_input_number, {
                            placeholder: "残業",
                            "addon-after": "H",
                            value: _ctx.registAchieve.overtime,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.registAchieve.overtime) = $event)),
                            min: 0,
                            style: {"float":"right","margin-right":"15px"},
                            inputmode: "decimal",
                            disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _createVNode(_component_a_divider, {
                          style: {"border-color":"#dee0e0"},
                          dashed: ""
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              _createTextVNode(" 補足"),
              _hoisted_47,
              _createVNode(_component_a_input, {
                placeholder: "補足",
                value: _ctx.registAchieve.action,
                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.registAchieve.action) = $event)),
                style: {"margin-right":"35px","margin-bottom":"20px"},
                disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
              }, null, 8, ["value", "disabled"])
            ]),
            (_ctx.registAchieve.project!=0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createTextVNode(" 追加変更"),
                  _hoisted_49,
                  _createVNode(_component_a_textarea, {
                    placeholder: "追加変更",
                    value: _ctx.registAchieve.addChange,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.registAchieve.addChange) = $event)),
                    style: {"margin-right":"35px","margin-bottom":"20px"},
                    disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
                  }, null, 8, ["value", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["open", "title", "onOk", "width"]),
      _createVNode(_component_a_modal, {
        open: _ctx.holidayVisible,
        "onUpdate:open": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.holidayVisible) = $event)),
        title: "休日登録",
        footer: null,
        onOk: _ctx.holidayRegist
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 休日として登録しますか？ "),
          _hoisted_50,
          (_ctx.getEditType(_ctx.registAchieve.staff) != 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.restmode,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.restmode) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "full" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全休")
                      ]),
                      _: 1
                    }),
                    _hoisted_51,
                    _createVNode(_component_a_radio, { value: "part" }, {
                      default: _withCtx(() => [
                        _createTextVNode("半休")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_52, [
                  _createTextVNode(" 休んだ時間 "),
                  _createVNode(_component_a_input_number, {
                    placeholder: "休んだ時間",
                    "addon-after": "H",
                    value: _ctx.registAchieve.achieve,
                    "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.registAchieve.achieve) = $event)),
                    min: 0,
                    style: {"float":"right","margin-right":"15px"},
                    inputmode: "decimal",
                    disabled: _ctx.restmode!='part'
                  }, null, 8, ["value", "disabled"])
                ]),
                _hoisted_53
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_54, [
            _createTextVNode(" 補足"),
            _hoisted_55,
            _createVNode(_component_a_input, {
              placeholder: "補足",
              value: _ctx.registAchieve.action,
              "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.registAchieve.action) = $event)),
              style: {"margin-right":"35px","margin-bottom":"20px"},
              disabled: _ctx.modalStaff!=_ctx.loginUserID&&!_ctx.loginUserAuthority
            }, null, 8, ["value", "disabled"])
          ]),
          _createVNode(_component_a_divider, { dashed: "" }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.holidayRegist,
            disabled: _ctx.getEditType(_ctx.registAchieve.staff) != 0&&(_ctx.restmode==null||_ctx.restmode=='part'&&!_ctx.registAchieve.achieve)
          }, {
            default: _withCtx(() => [
              _createTextVNode("登録")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 1
      }, 8, ["open", "onOk"])
    ])
  ], 64))
}